<template>
  <div class="split-view">
    <div class="left">
      <slot name="left"></slot>
    </div>
    <div class="divider"></div>
    <div class="right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GSSplitView'
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/vars/base';

.split-view {
  position: relative;
  overflow: hidden;
  width: 100%;

  .left {
    float: left;
    width: 50%;
    padding-right: $base-size * 40;
  }

  .right {
    float: left;
    width: 50%;
    padding-left: $base-size * 40;
  }

  .divider {
    position: absolute;
    left: 50%;
    height: 100%;
    border-left: 1px solid #455D6B;
    opacity: 0.65;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GSSplitView.vue